import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  AfterViewInit, inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogsService } from '@app/shared/services/dialogs/dialogs.service';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { ReviewsHeaderComponent } from '@app/salon-details/salon-details/reviews-header/reviews-header.component';
import { SalonModulesEnum } from '@app/shared/models/salon-modules.enum';
import { SalonReviewsComponent } from '@app/salon-details/salon-reviews/salon-reviews.component';
import { SalonService } from '@app/shared/services/salon/salon.service';
import { SalonDetailsBaseComponent } from '@app/salon-details/salon-details/salon-details.base.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  ScrollToCategoryComponent
} from '@app/salon-details/salon-details/scroll-to-category/scroll-to-category.component';
import { FeatherModule } from 'angular-feather';
import { CommonModule } from '@angular/common';
import { TreatmentCategoryComponent } from '@app/salon-details/treatment-category/treatment-category.component';
import { BadgeGiftsComponent } from '@app/shared/components/badge-gifts/badge-gifts.component';
import { OpeningHoursComponent } from '../../opening-hours/opening-hours.component';
import { BadgeGiftsDescriptionDumbComponent } from '@app/shared/components/badge-gifts/badge-gifts-description/badge-gifts-description.dumb.component';
import { inOutAnimation } from '@app/shared/utils/animations';
import { MultipleTreatmentsBasketComponent } from '../../multiple-treatments-basket/multiple-treatments-basket.component';

@Component({
  selector: 'app-salon-details-bjootify-context',
  templateUrl: './salon-details-bjootify-context.component.html',
  styleUrls: ['./salon-details-bjootify-context.component.scss'],
  standalone: true,
  animations: [inOutAnimation],
  imports: [
    CommonModule,
    TranslateModule,
    ScrollToCategoryComponent,
    TreatmentCategoryComponent,
    FeatherModule,
    BadgeGiftsComponent,
    OpeningHoursComponent,
    BadgeGiftsDescriptionDumbComponent,
    MultipleTreatmentsBasketComponent]
})
export class SalonDetailsBjootifyContextComponent extends SalonDetailsBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('reviewsHeader', { read: ViewContainerRef }) reviewsHeaderRef: ViewContainerRef;
  @ViewChild('reviewsSection', { read: ViewContainerRef }) salonReviewsRef: ViewContainerRef;
  @ViewChild('app-multiple-treatments-basket') multipleTreatmentsBasketRef: MultipleTreatmentsBasketComponent;
  public isMultipleTreatmentsBookingTurnedOn = false;

  constructor() {
    super(inject(ActivatedRoute),
      inject(Router),
      inject(SEOService),
      inject(DialogsService),
      inject(SalonService))
  }

  ngOnInit() {
    super.ngOnInit();
    this.isMultipleTreatmentsBookingTurnedOn = this.salonDetails.allowsBookingMultipleTreatmentsOnline;
  }

  ngAfterViewInit() {
    this.loadSalonFeatures();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private loadSalonFeatures(): void {
    if (this.salonDetails.modules.includes(SalonModulesEnum.Reviews)
      && this.salonDetails.reviewsCount > 0) {
      this.loadSalonReviews();
    }
  }

  private loadSalonReviews(): void {
    const reviewsHeaderRef = this.reviewsHeaderRef.createComponent<ReviewsHeaderComponent>(ReviewsHeaderComponent);
    reviewsHeaderRef.instance.cssClass = 'd-flex flex-row';
    reviewsHeaderRef.instance.salonDetails = this.salonDetails;
    reviewsHeaderRef.changeDetectorRef.detectChanges();

    const salonReviewsRef = this.salonReviewsRef.createComponent<SalonReviewsComponent>(SalonReviewsComponent);
    salonReviewsRef.instance.salonDetails = this.salonDetails;
    salonReviewsRef.instance.salonReviews = this.salonPage.salonReviews;
    salonReviewsRef.changeDetectorRef.detectChanges();
  }
}
